import {actions as A} from '../constants/actions';
import {sessionStorageKeys as S} from '../constants/sessionStorageKeys';
import {setSessionStorageItem} from '../utils/sessionStorage';

const defaultState = {
  regType: 'all',
};

export default (state = defaultState, {type, payload}) => {
  switch(type) {
    case A.SET_REG_TYPE:
      const {regType} = payload;
      setSessionStorageItem(S.REG_TYPE, regType);
      return {...state, regType};

    default:
      return state;
  }
}
